import React, { useRef, useEffect } from "react";
import { X } from "lucide-react";

export default function VideoPlayer({ videoUrl, onClose }) {
  const videoRef = useRef(null);

  useEffect(() => {
    // Al montar, iniciar el vídeo y poner el foco en botón cerrar
    if (videoRef.current) {
      videoRef.current.play();
    }
  }, [videoUrl]);

  const handleModalClick = (e) => {
    // Evitar cerrar modal si clicas en el video mismo
    e.stopPropagation();
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-90 flex justify-center items-center z-50 p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Reproductor de vídeo"
    >
      <video
        ref={videoRef}
        controls
        className="rounded max-h-[90vh] max-w-full"
        onEnded={onClose}
        onClick={handleModalClick}
      >
        <source src={videoUrl} type="video/mp4" />
        Tu navegador no soporta la reproducción de vídeo.
      </video>
      <button
        onClick={onClose}
        className="absolute top-6 right-6 bg-red-600 hover:bg-red-700 text-white rounded-full p-2"
        aria-label="Cerrar vídeo"
      >
        <X size={20} />
      </button>
    </div>
  );
}